import React from "react";

import { ICustomerCode } from "@origin-digital/shared-app-context";

import { Loading } from "src/components/Loading";
import { useSharedAppContext } from "src/context/SharedAppContext";

const getCustomerPath = (customerCode: ICustomerCode) =>
  customerCode === "SME" ? "business" : "home";

export const CustomerRedirect = () => {
  const { customerCode } = useSharedAppContext();

  if (customerCode) {
    const params = new URLSearchParams(window.location.search);
    const route = params.get("route");
    if (!route) {
      throw Error("Route not specified");
    }

    const redirectUrl = `/my-account/${getCustomerPath(customerCode)}${route}`;
    window.location.replace(redirectUrl);
  }

  return <Loading />;
};
